import React from 'react';
import {
  TwitterIcon,
  InstagramIcon,
  LinkedInIcon,
  GitHubIcon,
} from '../../assets/icons/Icons';

const SocialBar = () => {
  const socialMedia = [
    {
      name: 'Twitter',
      href: '',
      icon: <TwitterIcon />,
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/jacobogarcia0312/',
      icon: <InstagramIcon />,
    },
    {
      name: 'GitHub',
      href: 'https://github.com/Jacobo0312',
      icon: <GitHubIcon />,
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/in/juan-jacobo-g-3353bb13a/',
      icon: <LinkedInIcon />,
    },
  ];

  return (
    <div className="flex mt-10">
      {socialMedia.map(item => (
        <a
          href={item.href}
          key={item.name}
          className="text-gray-400 hover:text-gray-500 pr-5">
          {item.icon}
        </a>
      ))}
    </div>
  );
};

export default SocialBar;
